<div class="entity-hub-layout">
  @if (rowsValues.length == 0 && !isLoading) {
  <div class="empty-page">
    <div class="graphics-container">
      <img src="../../../../assets/icons/entities_graphics.svg" alt="entities_graphics" />
      <div class="entity-creation">
        <div class="entity-creation-text">
          Your next step is to add new entities to the taxonomy by clicking on the button below.
        </div>
        <app-taxonomy-button *ngIf="!taxonomyService.lockStatus" [buttonText]="'Create Entity'"
          [backgroundColor]="'#F2F1FF'" [Color]="'#534AD8'" [iconUrl]="'../../../../assets/icons/add-icon.svg'"
          (onButtonClick)="handleCreateEntity()">
        </app-taxonomy-button>

        <app-taxonomy-button *ngIf="taxonomyService.lockStatus" [buttonText]="'Create Entity'"
          [backgroundColor]="'#BFCCD9'" [Color]="'#FFFFFF99'" [iconUrl]="'../../../../assets/icons/grey-add-icon.svg'"
          (onButtonClick)="handleCreateEntity()" [disabled]="taxonomyService.lockStatus">
        </app-taxonomy-button>

      </div>
    </div>
  </div>
  }
  @else {

  @if (isLoading) {
  <div class="main-view-container-loader">
    <img [src]="'assets/icons/loading.svg'">
    <div style="margin-left: 8px;">Loading...</div>
  </div>
  } @else {
  <div class="entity-table-container">

    <!-- TABLE ACTIONS -->
    <div class="entity-table-actions">
      <!-- SEARCHBAR -->
      <div class="table-search-wrapper">
        <!-- SEARCH BAR -->
        <img src="../../../../assets/icons/search.svg" alt="search" />
        <input type="text" placeholder="Search by entity name" [(ngModel)]="searchTerm" (input)="filterRows()" />
      </div>
      <!-- TABLE-BTN -->

      <app-taxonomy-button *ngIf="!taxonomyService.lockStatus" [buttonText]="'Create Entity'"
        [backgroundColor]="'#F2F1FF'" [Color]="'#534AD8'" [iconUrl]="'../../../../assets/icons/add-icon.svg'"
        (onButtonClick)="handleCreateEntity()">
      </app-taxonomy-button>

      <app-taxonomy-button *ngIf="taxonomyService.lockStatus" [buttonText]="'Create Entity'"
        [backgroundColor]="'#BFCCD9'" [Color]="'#FFFFFF99'" [iconUrl]="'../../../../assets/icons/grey-add-icon.svg'"
        (onButtonClick)="handleCreateEntity()" [disabled]="taxonomyService.lockStatus">
      </app-taxonomy-button>

    </div>

    <!-- TABLE DISPLAY -->
    <div class="entity-table">
      <ngx-datatable class="material server-scrolling-demo table-class" [columns]="columnsHeader" [rows]="filteredRows"
        [columnMode]="'force'" [headerHeight]="50" [rowHeight]="'auto'" [footerHeight]="50">

        <ngx-datatable-column [name]="columnsHeader.length > 0 ? columnsHeader[0].name : 'Default Name'"
          [prop]="columnsHeader.length > 0 ? columnsHeader[0].prop : 'defaultProp'" [width]="100">

          <ng-template ngx-datatable-cell-template let-row="row">
            <div (click)="openEnitityForm(row)">
              {{ row[columnsHeader.length > 0 ? columnsHeader[0].prop : 'defaultProp'] || 'NA' }}
            </div>
          </ng-template>

        </ngx-datatable-column>

        <ngx-datatable-column *ngFor="let col of columnsHeader.slice(1)" [name]="col.name" [prop]="col.prop"
          [width]="320">

          <ng-template ngx-datatable-cell-template let-row="row">
            <div
              [ngClass]="{'role-highlight': col.prop === 'role',
                          'green-text': col.prop === 'entity_type' && row[col.prop]?.toLowerCase().includes('primary topic')}"
              (click)="openEnitityForm(row)">

              <!-- Handling Intents Column -->
              <ng-container *ngIf="col.prop === 'intents'; else defaultContent" class="intent-class">
                <div class="intent-class">
                  <span *ngFor="let intent of row[col.prop]" class="intent-badge">
                    {{ intent }}
                  </span>
                </div>

              </ng-container>

              <!-- Default Display -->
              <ng-template #defaultContent>
                {{ row[col.prop] || 'NA' }}
              </ng-template>
            </div>
          </ng-template>

        </ngx-datatable-column>

        <ngx-datatable-footer *ngIf="true">
          <ng-template ngx-datatable-footer-template let-rowCount="rowCount" let-pageSize="pageSize"
            let-selectedCount="selectedCount" let-curPage="curPage" let-offset="offset">
            <div class="row-count">
              <div>{{ rowCount }} Records</div>
            </div>
          </ng-template>
        </ngx-datatable-footer>

      </ngx-datatable>
    </div>

  </div>
  }
  }
</div>

<div class="overlay" (click)="onOverlayPress()" *ngIf="actionsService.displayForm">
</div>

<div class="form-popup" *ngIf="actionsService.displayForm">
  <app-entity-form></app-entity-form>
</div>
